import { useTranslation } from "react-i18next";
import ProducedSvg from "~/svgs/servicesPage/production/Produced";
import ImageTitleDescSlide, {
  ImageTitleDescSlideProps,
} from "./ImageTitleDescSlide";

export default function WorkshopSlide({
  produced,
  ...props
}: {
  produced: number;
} & ImageTitleDescSlideProps) {
  const { t } = useTranslation();

  return (
    <ImageTitleDescSlide {...props} imageClassName="object-contain ">
      {produced ? (
        <div className="mt-1 flex items-center gap-1">
          <ProducedSvg />

          <p className="text-Primary-Magic-Mint-Mm-300">
            +{produced} {t("pieces")}
          </p>
        </div>
      ) : null}
    </ImageTitleDescSlide>
  );
}
